<template>
    <div class="menu-wrapper" :class="{ 'layout-sidebar-active': sidebarActive }" @click="onMenuClick" @mouseover="onSidebarMouseOver" @mouseleave="onSidebarMouseLeave">
        <div class="sidebar-logo">
            <router-link to="/AdminManagement/AdminManagementList">
                <!-- <img src="assets/layout/images/Logo.png" style="height:35px;width:auto;" alt="D.A.LAB" /> -->
                <img v-show="rend2" src="../public/assets/layout/images/minilogo.png" style="height: 35px; width: auto" alt="InsideJobs" />
                <img v-show="rend" src="../src/assets/layout/images/logininside.png" alt="InsideJobs" style="width: auto; height: 35px" />
                <!-- <b style="padding-left: 15px; font-size: 23px;color:#728FCE">{{ title }}</b> -->
                <!-- assets/layout/images/wallet.png -->
            </router-link>
            <a class="sidebar-pin" @click="onToggleMenu($event)">
                <span class="pin"></span>
            </a>
        </div>

        <div class="layout-menu-container">
            <AppSubmenu
                class="layout-menu"
                :items="filterMenu"
                :layoutMode="layoutMode"
                :parentMenuItemActive="true"
                :menuActive="menuActive"
                :mobileMenuActive="mobileMenuActive"
                :root="true"
                @menuitem-click="onMenuItemClick"
                @root-menuitem-click="onRootMenuItemClick"
            />
            <div @click="logout">
                <div>
                    <span class="logout-btn">
                        <i class="pi pi-sign-out"></i>
                        {{ mouse_over ? $t('logout') : '' }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppSubmenu from './AppSubmenu';
import MenuService from './service/API/MenuService';
// import PositionOfferService from '../src/service/API/PositionOfferService';
export default {
    name: 'AppMenu',
    emits: ['menu-click', 'menuitem-click', 'root-menuitem-click', 'toggle-menu', 'sidebar-mouse-over', 'sidebar-mouse-leave'],
    props: {
        sidebarActive: Boolean,
        sidebarStatic: Boolean,
        layoutMode: String,
        menuActive: Boolean,
        mobileMenuActive: Boolean,
    },
    data() {
        return {
           
            mouse_over: false,
            rend: false,
            adminset: '',
            superadmin: [
                // { label: 'Dashboard', icon: 'pi pi-home', to: '/' },
                { label: this.$t(`module.title.DFCMangement`), icon: 'pi pi-users', to: '/dfc-management' },
                // { label: this.$t(`module.title.BannerMangement`), icon: 'pi pi-images', to: '/banner-management' },
                // { label: this.$t(`module.title.PopupMangement`), icon: 'pi pi-question-circle', to: '/popup-management' },
                // { label: this.$t(`module.title.NFTMangement`), icon: 'pi pi-bell', to: '/nft-management' },
                // { label: this.$t(`module.title.CardnewsMangement`), icon: 'pi pi-book', to: '/card-news' },
                // { label: this.$t(`module.title.MediaPressMangement`), icon: 'pi pi-bell', to: '/media-press' },
                // { label: this.$t(`module.title.GoogleformsMangement`), icon: 'pi pi-tags', to: '/google-form' },
                // { label: this.$t(`module.title.FrontendPopupManagement`), icon: 'pi pi-desktop', to: '/FrontendPopup-management' },
            ],

            dfc_user: [{ label: this.$t(`module.title.Client-lookup`), icon: 'pi pi-users', to: '/client-lookup' }],
            menu: [
                { label: 'Dashboard', icon: 'pi pi-home', to: '/' },
                { label: 'User management', icon: 'pi pi-users', to: '/user' },
                { label: 'Banner management', icon: 'pi pi-images', to: '/banner-management' },
                { label: 'FAQ', icon: 'pi pi-question-circle', to: '/faq' },
                { label: 'Notice', icon: 'pi pi-bell', to: '/notice' },
                { label: 'CMS', icon: 'pi pi-book', to: '/cms' },
                {
                    label: 'Inquiry',
                    icon: 'pi pi-inbox',
                    items: [
                        { label: 'Inquiry type', icon: 'pi pi-tags', to: '/inquiry-type' },
                        { label: '1:1 inquiry', icon: 'pi pi-comments', to: '/inquiry' },
                    ],
                },
                // onprogress ==> file not ready , when the file ll be ready change the path
                {
                    label: 'UI Kit',
                    icon: 'pi pi-star-o',
                    items: [
                        { label: 'Form Layout', icon: 'pi pi-id-card', to: '/formlayout' },
                        { label: 'Input', icon: 'pi pi-check-square', to: '/input' },
                        { label: 'Float Label', icon: 'pi pi-bookmark', to: '/floatlabel' },
                        { label: 'Invalid State', icon: 'pi pi-exclamation-circle', to: '/invalidstate' },
                        { label: 'Button', icon: 'pi pi-mobile', to: '/button', class: 'rotated-icon' },
                        { label: 'Table', icon: 'pi pi-table', to: '/table' },
                        { label: 'List', icon: 'pi pi-list', to: '/list' },
                        { label: 'Tree', icon: 'pi pi-share-alt', to: '/tree' },
                        { label: 'Panel', icon: 'pi pi-tablet', to: '/panel' },
                        { label: 'Overlay', icon: 'pi pi-clone', to: '/overlay' },
                        { label: 'Media', icon: 'pi pi-image', to: '/media' },
                        { label: 'Menu', icon: 'pi pi-bars', to: '/menu' },
                        { label: 'Message', icon: 'pi pi-comment', to: '/messages' },
                        { label: 'File', icon: 'pi pi-file', to: '/file' },
                        { label: 'Chart', icon: 'pi pi-chart-bar', to: '/chart' },
                        { label: 'Misc', icon: 'pi pi-circle-off', to: '/misc' },
                    ],
                },
                {
                    label: 'Utilities',
                    icon: 'pi pi-compass',
                    items: [
                        { label: 'Display', icon: 'pi pi-desktop', to: '/display' },
                        { label: 'Elevation', icon: 'pi pi-external-link', to: '/elevation' },
                        { label: 'Flexbox', icon: 'pi pi-directions', to: '/flexbox' },
                        { label: 'Icons', icon: 'pi pi-search', to: '/icons' },
                        { label: 'Text', icon: 'pi pi-pencil', to: '/text' },
                        { label: 'Widgets', icon: 'pi pi-star-o', to: '/widgets' },
                        { label: 'Grid System', icon: 'pi pi-th-large', to: '/grid' },
                        { label: 'Spacing', icon: 'pi pi-arrow-right', to: '/spacing' },
                        { label: 'Typography', icon: 'pi pi-align-center', to: '/typography' },
                    ],
                },
                {
                    label: 'Pages',
                    icon: 'pi pi-briefcase',
                    items: [
                        { label: 'Crud', icon: 'pi pi-pencil', to: '/crud' },
                        { label: 'Calendar', icon: 'pi pi-calendar-plus', to: '/calendar' },
                        { label: 'Timeline', icon: 'pi pi-calendar', to: '/timeline' },
                        { label: 'Landing', icon: 'pi pi-globe', url: 'assets/pages/landing.html', target: '_blank' },
                        { label: 'Login', icon: 'pi pi-sign-in', to: '/login' },
                        { label: 'Invoice', icon: 'pi pi-dollar', to: '/invoice' },
                        { label: 'Help', icon: 'pi pi-question-circle', to: '/help' },
                        { label: 'Error', icon: 'pi pi-times-circle', to: '/error' },
                        { label: 'Not Found', icon: 'pi pi-exclamation-circle', to: '/notfound' },
                        { label: 'Access Denied', icon: 'pi pi-lock', to: '/access' },
                        { label: 'Empty', icon: 'pi pi-circle-off', to: '/empty' },
                    ],
                },
                {
                    label: 'Hierarchy',
                    icon: 'pi pi-align-left',
                    items: [
                        {
                            label: 'Submenu 1',
                            icon: 'pi pi-align-left',
                            items: [
                                {
                                    label: 'Submenu 1.1',
                                    icon: 'pi pi-align-left',
                                    items: [
                                        { label: 'Submenu 1.1.1', icon: 'pi pi-align-left' },
                                        { label: 'Submenu 1.1.2', icon: 'pi pi-align-left' },
                                        { label: 'Submenu 1.1.3', icon: 'pi pi-align-left' },
                                    ],
                                },
                                {
                                    label: 'Submenu 1.2',
                                    icon: 'pi pi-align-left',
                                    items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-align-left' }],
                                },
                            ],
                        },
                        {
                            label: 'Submenu 2',
                            icon: 'pi pi-align-left',
                            items: [
                                {
                                    label: 'Submenu 2.1',
                                    icon: 'pi pi-align-left',
                                    items: [
                                        { label: 'Submenu 2.1.1', icon: 'pi pi-align-left' },
                                        { label: 'Submenu 2.1.2', icon: 'pi pi-align-left' },
                                    ],
                                },
                                {
                                    label: 'Submenu 2.2',
                                    icon: 'pi pi-align-left',
                                    items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-align-left' }],
                                },
                            ],
                        },
                    ],
                },
                {
                    label: 'Start',
                    icon: 'pi pi-download',
                    items: [
                        { label: 'Buy Now', icon: 'pi pi-shopping-cart', command: () => window.open('https://www.primefaces.org/store', '_blank') },
                        { label: 'Documentation', icon: 'pi pi-info-circle', to: '/documentation' },
                    ],
                },
            ],
            filterMenu: [],
        };
    },
    computed: {
        InsideJob() {
            return [
                // { label: 'Dashboard', icon: 'pi pi-home', to: '/' },
                // { label: this.$t(`User Management`), icon: 'pi pi-users', to: '/user' },
                { label: this.$t(`Admin Management`), title: 'Admin Management', icon: 'pi pi-user', to: '/AdminManagement/AdminManagementList' },
                { label: this.$t(`Member Statistics`), title: 'Member Statistics', icon: 'pi pi-chart-line', to: '/MemberStatistics/MemberStatisticslist' },

                {
                    label: this.$t(`Member Management`),
                    title: 'Member Management',
                    icon: 'pi pi-id-card',
                    items: [
                        { label: this.$t('Job Seeker'), icon: 'pi pi-search', to: '/MemberManagement/JobSeeker/JobSeekerList' },
                        { label: this.$t('Recruiter'), icon: 'pi pi-briefcase', to: '/MemberManagement/Recruiter/Recruiterlist' },
                    ],
                },
                { label: this.$t(`Purchase Management`), title: 'Purchase Management', icon: 'pi pi-wallet', to: '/PurchaseManagement/PurchaseManagementlist' },
                {
                    label: this.$t(`Paid Feature Management`),
                    title: 'Paid Feature Management',
                    icon: 'pi pi-dollar',
                    items: [
                        { label: this.$t('Emergency'), icon: 'pi pi-shield', to: '/PaidFeatureManagement/Emergency/EmergencyList' },
                        { label: this.$t('Premium'), icon: 'pi pi-key', to: '/PaidFeatureManagement/Premium/PremiumList' },
                        { label: this.$t('Special'), icon: 'pi pi-search', to: '/PaidFeatureManagement/Special/SpecialList' },
                        { label: this.$t('Line'), icon: 'pi pi-briefcase', to: '/PaidFeatureManagement/Line/LineList' },
                        { label: this.$t('Free'), icon: 'pi pi-search', to: '/PaidFeatureManagement/Free/FreeList' },
                        { label: this.$t('Upgle'), icon: 'pi pi-briefcase', to: '/PaidFeatureManagement/Upgle/UpgleList' },
                        { label: this.$t('Talent Search'), icon: 'pi pi-search', to: '/PaidFeatureManagement/TalentSearch/TalentSearchList' },
                        { label: this.$t('Package'), icon: 'pi pi-briefcase', to: '/PaidFeatureManagement/PackageManagement/PackageList' },
                        { label: this.$t('Chodan Coin'), icon: 'pi pi-search', to: '/PaidFeatureManagement/ChodanCoin/ChodanCoinList' },
                        // { label: this.$t('Recruiter'), icon: 'pi pi-briefcase', to: '/statistics/product_category' },
                    ],
                },
                {
                    label: this.$t(`Board Management`),
                    title: 'Board Management',
                    icon: 'pi pi-bell',
                    items: [
                        { label: this.$t('Notice'), icon: 'pi pi-comments', to: '/notice/NoticeList' },
                        { label: this.$t('Banner Management'), icon: 'pi pi-question-circle', to: '/BannerManagemet/BannerList' },
                    ],
                },
                {
                    label: this.$t(`Information Management`),
                    title: 'Information Management',
                    icon: 'pi pi-book',
                    items: [
                        { label: this.$t('Service Terms'), icon: 'pi pi-comments', to: '/ServiceTerms/ServiceTermsList' },
                        { label: this.$t('General'), icon: 'pi pi-question-circle', to: '/General/GeneralList' },
                    ],
                },
                { label: this.$t(`Labor Counsel`), title: 'Labor Counsel', icon: 'pi pi-sitemap', to: '/inquiry/Inquiry' },
                { label: this.$t(`Post From Other Platform Request`), title: 'Post From Other Platform Request', icon: 'pi pi-briefcase', to: '/PostOtherPlatform/PostOtherPlatformRequestList' },
                { label: this.$t(`Position Offer`), title: 'Position Offer', icon: 'pi pi-envelope', to: '/PositionOffer/PositionOfferlist' },

                // { label: this.$t(`Survey List`), icon: 'pi pi-book', to: '/survey' },
                // { label: this.$t(`Receipt Info`), icon: 'pi pi-tags', to: '/receipt' },
                // { label: this.$t(`Coupon Management`), icon: 'pi pi-check-square', to: '/coupon' },
                // { label: this.$t(`Notification Management`), icon: 'pi pi-list', to: '/notification' },
            ];
        },
    },
    mounted() {
        this.menuService = new MenuService();

        this.UserMenuList();
        // if (localStorage.getItem('admin-type') === 'admin') {
        //     this.adminset = this.superadmin;
        // }else{
        //     this.adminset = this.dfc_user;
        // }
        // this.GetFirstLevel();

        // const date = new Date();
        // const options = { hour12: true };
        // const timeFormat = date.toLocaleTimeString(undefined, options);
        // if (timeFormat.includes('AM') || timeFormat.includes('PM')) {
        //     localStorage.setItem('SystemTIme', '12hr');
        //     console.log('12-hour format');
        // } else {
        //     localStorage.setItem('SystemTIme', '24hr');
        //     console.log('24-hour format');
        // }
    },
    // created() {
    //     this.detectTimeFormat();
    //     // const timeFormat = detectTimeFormat();
    //     this.SystemTime =  this.detectTimeFormat()
    //     // console.log('Detected time format:', this.detectTimeFormat());
    // },
    methods: {
        

        // // Usage example
        // const timeFormat = detectTimeFormat()
        // console.log('Detected time format:', timeFormat),
        UserMenuList() {
            // console.log(this.InsideJob)
            this.menuService
                .GetUserMenuList()
                .then((res) => {
                    this.results = res.data;
                    // console.log(res.data);
                    const results = this.InsideJob.filter(({ title: xyz }) => this.results.some(({ menu_name: id2 }) => id2 === xyz));
                    this.filterMenu = results;

                    // localStorage.setItem("DynamicPath",results[0].to);
                    // this.$router.push({ path: results[0].to  });
                    localStorage.removeItem('DynamicPath');
                    // console.log(results);
                })
                .catch((err) => console.log(err));
        },
        // GetFirstLevel() {
        //     this.positionOfferService.FirstOccupation().then((res) => {
        //         console.log(res);
        //         localStorage.setItem('FirstLevel',JSON.stringify(res))

        //     });
        // },

        onSidebarMouseOver() {
            if (this.layoutMode === 'sidebar' && !this.sidebarStatic) {
                this.$emit('sidebar-mouse-over');
                this.rend = true;
                this.rend2 = false;
                this.mouse_over = true;
            }
        },
        onSidebarMouseLeave() {
            if (this.layoutMode === 'sidebar' && !this.sidebarStatic) {
                setTimeout(() => {
                    this.$emit('sidebar-mouse-leave');
                    this.rend = false;
                    this.rend2 = true;
                    this.mouse_over = false;
                }, 250);
            }
        },
        logout() {
            localStorage.removeItem('AdminName');
            localStorage.removeItem('AdminId');
            localStorage.removeItem('token');
            this.$router.push({ name: 'login' });
        },
        // onSidebarMouseLeave() {
        //     if (this.layoutMode === 'sidebar' && !this.sidebarStatic) {
        //         setTimeout(() => {
        //             this.$emit('sidebar-mouse-leave');
        //             this.rend = false;
        //             this.mouse_over = false;
        //         }, 250);
        //     }
        // },
        onToggleMenu(event) {
            this.$emit('toggle-menu', event);
        },
        onMenuClick(event) {
            this.$emit('menu-click', event);
        },
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        },
        onRootMenuItemClick(event) {
            this.$emit('root-menuitem-click', event);
        },
    },
    components: { AppSubmenu },
};
</script>
<style>
.logout-btn {
    position: absolute;
    bottom: 20px;
    display: block;
    width: 100%;
    padding: 0 20px;
    color: #000;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
}

.logout-btn:hover {
    color: var(--primary-color);
}

.logout-btn i {
    font-size: 24px;
    vertical-align: middle;
}

.p-button2 {
    background: transparent;
    border: none;
    color: #000;
}
</style>
